<template>
  <div class="communitySearch">
    <div class="data" ref="communityList">
      <h1>Pretraga zajednica</h1>

      <input
        class="form-control community-search"
        placeholder="Pretražite zajednice..."
        @input="debounceInput"
        v-model="searchValue"
      />
      <div
        class="community-item"
        v-for="comm in communities"
        :key="comm.id"
        @click="showCommunityMarker(comm)"
        ref="communities"
        :style="
          comm.id == selectedCommunity.id
            ? {
                background:
                  'linear-gradient(0deg, rgba(255,255,255, 0.15), rgba(255,255,255, 0.15)), url(&quot;' +
                  baseURL +
                  comm.img +
                  '&quot;)'
              }
            : {
                background:
                  'linear-gradient(0deg, rgba(4,121,106, 0.5), rgba(4,121,106, 0.5)), url(&quot;' +
                  baseURL +
                  comm.img +
                  '&quot;)'
              }
        "
      >
        <div class="community-item-content community-item-content-white">
          <span class="community-name"> {{ comm.name }}</span>
          <br />
          <button
            type="submit"
            class="btn btn-primary btn--mod"
            @click="setCommunityForActive(comm.id, comm.name)"
          >
            <span>Izaberi zajednicu</span>
          </button>
        </div>
      </div>
    </div>
    <div class="map">
      <gmap-map
        ref="mapRef"
        :zoom="zoom"
        :center="mapCenter"
        map-type-id="roadmap"
        style="width: 100%; height: 100%"
      >
        <gmap-info-window
          :options="infoOptions"
          :position="infoPosition"
          :opened="infoOpened"
          @closeclick="infoOpened = false"
        >
          <div>
            <h5>{{ selectedCommunity.name }}</h5>
          </div>
        </gmap-info-window>
        <gmap-marker
          v-for="(item, key) in coordinates"
          :key="key"
          :position="item"
          :clickable="true"
          @click="toggleInfo(item, key)"
        />
      </gmap-map>
    </div>
  </div>
</template>

<script>
import axios from '@/axios/axios.js';
import { mapActions, mapState, mapMutations } from 'vuex';
import dataTable from '@/components/community/Table.vue';
import Pagination from '@/components/common/Pagination.vue';
import debounce from 'debounce';

export default {
  name: 'communitySearchView',
  mounted() {
    this.$refs.mapRef.$mapPromise.then(map => {
      const bounds = new google.maps.LatLngBounds();
      for (const coordinate of this.coordinates) {
        console.log(this.baseURL + coordinate.imgThumb);
        const loc = new google.maps.LatLng(coordinate.lat, coordinate.lng);
        bounds.extend(loc);
      }
      // auto zoom
      map.fitBounds(bounds);
      // auto center
      map.panToBounds(bounds);
      setTimeout(() => {
        if (map.zoom > 15) {
          this.zoom = 15;
        }
      }, 100);
    });
  },
  created() {
    this.coordinates = this.$store.getters.getCommunitiesImploded;
    this.communities = this.$store.getters.getCommunitiesImploded;
  },
  data() {
    return {
      baseURL: process.env.VUE_APP_OBJECT_STORAGE_URL,
      mapCenter: {
        lat: 44.80225560855148,
        lng: 20.446508858257303
      },
      zoom: 11,
      coordinates: {
        0: {
          full_name: 'Erich  Kunze',
          lat: 44.80225560855148,
          lng: 20.446508858257303
        }
      },
      infoPosition: null,
      infoContent: null,
      infoOpened: false,
      infoCurrentKey: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      selectedCommunity: '',
      communities: [],
      searchValue: ''
    };
  },
  computed: {
    ...mapState('table', ['tableColumns', 'tableData', 'tableOptions'])
  },
  components: {
    // Pagination
  },
  methods: {
    ...mapMutations(['setActiveCommunity']),
    debounceInput: debounce(function(e) {
      this.search(e.target.value);
    }, 100),
    search() {
      this.communities = this.coordinates.filter(c =>
        c.name.toLowerCase().includes(this.searchValue.toLowerCase())
      );
    },
    setPlace(place) {
      this.mapCenter = place.geometry.location;
      this.zoom = 14;
    },
    showCommunityMarker(comm) {
      const key = this.coordinates.findIndex(c => c.id == comm.id);
      this.selectedCommunity = comm;
      this.infoPosition = comm;
      this.infoContent = comm.full_name;
      this.infoOpened = true;
      this.infoCurrentKey = key;
    },
    toggleInfo: function(marker, key) {
      this.searchValue = '';
      this.search();
      this.selectedCommunity = marker;
      this.infoPosition = marker;
      this.infoContent = marker.full_name;
      if (this.infoCurrentKey == key) {
        this.infoOpened = !this.infoOpened;
      } else {
        this.infoOpened = true;
        this.infoCurrentKey = key;
      }
      switch (key) {
        case 0:
          this.$refs.communities[key].scrollIntoView();
          this.$nextTick(function() {
            this.$refs.communityList.scrollBy(0, -200);
          });
          break;
        case 1:
          this.$refs.communities[key - 1].scrollIntoView();
          this.$nextTick(function() {
            this.$refs.communityList.scrollBy(0, -300);
          });
          break;
        default:
          this.$refs.communities[key - 1].scrollIntoView();
      }
    },
    setCommunityForActive(id, name) {
      this.setActiveCommunity(id);
      this.$toasted.show(`Izabrana zajednica promenjena na: ${name}`);
      this.$router.push({
        name: 'communityMembers',
        params: { id: id }
      });
    }
  }
};
</script>

<style lang="scss">
.communitySearch {
  width: 100%;
  height: 100vh;
  display: flex;
  .community-item {
    // max-width: 405px;
    margin: 16px auto;
    border-radius: 8px;
    // box-shadow: 0 2px 7px 1px rgba(0, 0, 0, 0.3);
    padding: 12px;
    text-align: center;
    user-select: none; /* standard syntax */
    -webkit-user-select: none; /* webkit (safari, chrome) browsers */
    -moz-user-select: none; /* mozilla browsers */
    -khtml-user-select: none; /* webkit (konqueror) browsers */
    -ms-user-select: none; /* IE10+ */
    display: flex;
    background-repeat: no-repeat !important;
    background-position: center !important;
    background-size: cover !important;
    min-height: 180px;
    font-weight: 800;
    cursor: pointer;
    .community-item-content-white {
      color: white;
    }
    .community-item-content-black {
      color: black;
    }
    .community-item-content {
      margin: auto;
      text-align: center;
    }
    &:hover {
      filter: brightness(122%);
      -webkit-filter: brightness(122%);
      -moz-filter: brightness(122%);
    }
  }
  .community-item.selected {
    border: 4px solid #004d44;
  }
  .community-search {
    margin-bottom: 16px;
    margin-top: 0.1rem;
  }
  .data {
    // margin-top: 10px;
    flex: 1;
    padding: 0rem 1rem 2rem 1rem;
    font-size: 1.5rem;
    height: 100%;
    overflow: auto;
    &__header {
      text-align: center;
      color: var(--primary-color);
      margin-bottom: 3rem;
    }

    &__img-input-wrapper {
      display: inline-flex;
      justify-content: space-between;
      width: 100%;
    }
  }

  .map {
    flex: 2;
    position: relative;

    &__marker {
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -60px;
      margin-left: -30px;
    }
  }
}
</style>
